<ng-container *ngIf="!hasError; else error">
  <div *ngIf="singleNews$ | async as singleNews; else loader" class="news-container">
    <app-news-element
      [newsElement]="singleNews"
      [isHeaderSelectable]="false"
      [areCommentsExpanded]="true"
      (reloadNews)="reloadNews()"
    ></app-news-element>
  </div>
</ng-container>

<ng-template #loader>
  <div class="shadowed-main-block">
    <div class="loader">
      <mat-spinner diameter="80" strokeWidth="5" color="accent"></mat-spinner>
    </div>
  </div>
</ng-template>

<ng-template #error>
  <div class="shadowed-main-block error">
    <span translate translation="errorNewsDoesntExist"></span>
  </div>
</ng-template>
